import t from "react";
import { TextInput as p } from "../TextInput/TextInput.js";
function l(e) {
  const {
    formOptions: a,
    required: r,
    ...o
  } = e, s = {
    validate: (n) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?){1,}$/.test(n),
    ...a,
    required: r
  };
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "email-input" }, /* @__PURE__ */ t.createElement(
    p,
    {
      type: "email",
      ...o,
      formOptions: s
    }
  ));
}
export {
  l as EmailInput
};
//# sourceMappingURL=EmailInput.js.map
